
import { mapGetters } from "vuex";

export default {
    name: "fastSell",
    data() {
        return {
            articleDetail: null,
            centerDialogVisible: false,
        }
    },
    computed: {
        ...mapGetters(
            {
                exposureNum: 'game/exposureNum'
            }
        )
    },
    methods: {
        // 查看极速卖须知
        getNotice() {
            debugger
            let data = {
                action: {
                    id: 49
                }
            }
            this.$api.getHagglingDetail(data).then(res => {
                if (res.success) {
                    this.articleDetail = res.data
                    this.centerDialogVisible = true
                } else {
                    this.$message.error(res.info)
                }
            })
        },
    },
    mounted() {
        this.$store.dispatch('game/ExposureNum')
    }
}
